import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';

@Component({
  selector: 'app-pregunta-inicio',
  templateUrl: './pregunta-inicio.component.html',
  styleUrls: ['./pregunta-inicio.component.scss']
})
export class PreguntaInicioComponent implements OnInit {

  constructor(
    private readonly globalService: GlobalesService
  ) { }

  ngOnInit(): void {
    this.globalService.menuActual = 'PreguntasFrecuentes';
    this.globalService.unselectContiendas();
  }

}
